import type { ReactElement } from 'react';
import { Prompt, Typography } from '@weareopenr/component-library';
import promptStyles from './CancelScheduledPublicationPrompt.module.scss';

interface Props {
  open: boolean;
  name: string;
  scheduleDate: Date;
  closePrompt: VoidFunction;
  deleteButtonHandler: VoidFunction;
}

const formatDate = (date: Date): string =>
  date
    .toLocaleDateString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replaceAll('/', '.');

const formatTime = (date: Date): string => date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const CancelScheduledPublicationPrompt = ({
  open: isOpen,
  name: selectedMenuName,
  scheduleDate: scheduledDate,
  closePrompt: onClose,
  deleteButtonHandler: onDelete,
}: Props): ReactElement => (
  <Prompt
    data-testid="close-delete-menu-prompt"
    closePrompt={onClose}
    open={isOpen}
    buttonHandler={onDelete}
    buttonText="Cancel Schedule"
    promptHeading="Are you sure you want to cancel the publication?"
    size="small"
  >
    <>
      <Typography className={promptStyles['prompt-text']}>You will cancel the publication of the following:</Typography>
      <Typography weight="semi-bold" className={promptStyles['prompt-text']}>
        {selectedMenuName}
      </Typography>
      <Typography>
        Scheduled to be published at <strong>{scheduledDate ? formatDate(scheduledDate) : ''}</strong> at{' '}
        <strong>{scheduledDate ? formatTime(scheduledDate) : ''}</strong>
      </Typography>
    </>
  </Prompt>
);
